/* Статус трансфера сотрудника на другой филиал */

export default class WorkScheduleTransferStatus {
  static get Transferred () { return 'transferred' }
  static get Wait () { return 'wait' }
  static get Arrived () { return 'arrived' }
}
